import { render, staticRenderFns } from "./LinksAdmin.vue?vue&type=template&id=461c2031&scoped=true"
import script from "./LinksAdmin.vue?vue&type=script&lang=js"
export * from "./LinksAdmin.vue?vue&type=script&lang=js"
import style0 from "./LinksAdmin.vue?vue&type=style&index=0&id=461c2031&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c2031",
  null
  
)

export default component.exports